import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import RadioButtonGroup from 'common/radio-button-group/RadioButtonGroup';
import {setTerm} from 'search-request/search-request-actions';

class SearchTermToggle extends Component {
    static propTypes = {
        city: PropTypes.object,
        destination: PropTypes.shape(DESTINATION_DATA).isRequired,
        isMonthly: PropTypes.bool,
        isAirport: PropTypes.bool,
        includeAirport: PropTypes.bool,
        isSearching: PropTypes.bool,
        setSearchTerm: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        const {isMonthly, isAirport, includeAirport} = props;

        this._items = [
            {
                label: 'Hourly',
                value: 'daily',
                checked: !isMonthly && !isAirport,
            },
            {
                label: 'Monthly',
                value: 'monthly',
                checked: isMonthly && !isAirport,
            },
        ];

        if (includeAirport) {
            this._items.push({
                label: 'Airport',
                value: 'airport',
                checked: isAirport,
            });
        }
    }

    _onChange = ({value}) => {
        const {city, destination, setSearchTerm} = this.props;

        setSearchTerm({
            term: value,
            city,
            destination,
        });
    };

    render() {
        const {isSearching} = this.props;

        return (
            <RadioButtonGroup
                className="SearchTermToggle"
                color="secondary"
                initialItems={this._items}
                disabled={isSearching}
                onChange={this._onChange}
            />
        );
    }
}

const mapStateToProps = ({
    city: {data: city},
    destination: {data: destination},
    searchRequest: {monthly, airport},
}) => {
    return {
        isMonthly: monthly,
        isAirport: airport,
        city,
        destination,
    };
};

const mapDispatchToProps = {
    setSearchTerm: setTerm,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchTermToggle);
